import React, {useEffect} from 'react'
import {Route, Redirect, Switch, useHistory} from 'react-router-dom'
import {EmployeeHome} from '../Authenticated/Employee/EmployeeHome/EmployeeHome'
import Profile from '../Authenticated/Employee/Profile/Profile'
import {Saved} from '../Authenticated/Employee/Saved/Saved'
import Submissions from '../Authenticated/Employee/Submissions/Submissions'
import {Job} from "../UnAuthenticated/Job/Job";
import {CompanyPage} from "../UnAuthenticated/Company/CompanyPage";
import {NotFound} from "../components/NotFound/NotFound";
import {Complaint} from '../Authenticated/Employee/complaint/complaint'
import Logout from '../Authenticated/Logout'

const AuthenticatedEmployee: React.FC = () => {
    const history = useHistory();
    useEffect(() => {
                var url: string | null = sessionStorage.getItem('url');
                if(url != null && url.length > 0) {
                    history.push(url)
                    sessionStorage.removeItem('url')
                }
            }
            // eslint-disable-next-line
            , [])
    return (
            <React.Fragment>
                <Switch>

                    <Redirect exact from='/' to='/employee/home'/>
                    <Redirect exact from='/login' to='/employee/home'/>
                    <Redirect exact from='/jobs' to='/employee/home'/>
                    <Redirect exact from='/jobs/graduates' to='/employee/home'/>
                    <Redirect exact from='/employee/step' to='/employee/home'/>

                    <Route path='/employee/home' exact component={EmployeeHome}/>


                    <Route path='/employee/status' exact component={Submissions}/>
                    <Route path='/employee/saved' exact component={Saved}/>
                    <Route path='/company/:id' exact>

                        <CompanyPage withoutHeader={true}/>
                    </Route>
                    <Route path='/employee/profile' exact component={Profile}/>
                    <Route path='/employee/job/:id' exact component={Job}/>
                    <Route path='/employee/profile/info' exact render={() => <Profile img={true}/>}/>
                    <Route path='/employee/complaint' exact render={() => <Complaint/>}/>
                    <Redirect exact from='/job/:id' to='/employee/job/:id' />
                    <Redirect exact from='/jobs/:id' to='/employee/job/:id' />
                    <Route path='/logout' exact component={Logout}/>
                    <Route path='/404' exact component={NotFound}/>
                    <Redirect from='*' to='/404'/>
                </Switch>
            </React.Fragment>
    )
}
export default AuthenticatedEmployee